module.exports = __webpack_public_path__ + "img/henry-jarvis-raymond.4aa66cc9.png";